export { default } from './CamAdPlayer';
